<template>
    <div>
        <modal-new-recap></modal-new-recap>

        <div class="content-wrapper" v-if="!loadingComplete()">
            <section class="content">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header">
                            <h3 class="box-title">Chargement en cours</h3>
                        </div>
                        <div class="box-body">
                            Chargement du récapitulatif
                        </div>
                        <div class="overlay">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="content-wrapper" v-if="loadingComplete()">
            <!-- Content Header (Page header) -->
            <section class="content-header" v-if="recap_id!=0">
                <h1>
                    Récapitulatif "{{getRecap.club.club}}"
                    <small> #{{getRecap.id}}</small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li><a href="#">Récapitulatifs</a></li>
                    <li class="active"><a href="#">#{{getRecap.id}}</a></li>
                </ol>
            </section>

            <section class="content-header" v-if="recap_id==0">
                <h1>
                    Récapitulatifs
                    <small></small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li class="active"><a href="#">Récapitulatifs</a></li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li :class="{ 'active': recap_id!=0 }" v-if="recap_id!=0">
                                    <a href="#member_tab_1"
                                       aria-controls="#member_tab_1"
                                       data-toggle="tab"
                                       aria-expanded="false">Fiche du récapitulatif</a>
                                </li>
                                <li :class="{ 'active': recap_id==0 }">
                                    <a href="#member_tab_2"
                                       aria-controls="#member_tab_2"
                                       data-toggle="tab"
                                       aria-expanded="false">Listing des récapitulatifs</a>
                                </li>

                                <li class="pull-right">
                                    <a @click.prevent="showModalNewRecap()">Ajouter un récapitulatif</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div v-if="recap_id!=0" role="tabpanel" class="col-md-12 tab-pane" :class="{ 'active': recap_id!=0 }" id="member_tab_1">
                        <MainFormRecap
                                v-if="recap_id!=0"
                                :loadingTableMembres="loading"
                                @onNeedRefreshRecap="refreshRecap()"
                        ></MainFormRecap>
                    </div>

                    <div role="tabpanel" class="col-md-12 tab-pane" :class="{ 'active': recap_id==0 }" id="member_tab_2">
                        <ListingRecap
                                :clubPreSelected="clubSelectedForFilter">
                        </ListingRecap>
                    </div>

                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MainFormRecap from './MainFormRecap.vue'
    import ModalNewRecap from './ModalNewRecap'
    import ListingRecap from './ListingRecap'

    export default {
        data() {
            return {
                loading: false,
                recap_id: null,
                clubSelectedForFilter: 0
            }
        },
        props: {},
        computed: {
            ...mapGetters({
                getRecap: 'getRecap',
                getStatusRecap: 'getStatusRecap',
                getRoute: 'getRoute',
            })
        },
        methods: {
            ...mapActions({
                setRecap: 'setRecap',
                setStatusRecap: 'setStatusRecap',
                setTextesRecap: 'setTextesRecap',
            }),
            showModalNewRecap: function () {
                $('#modalNewRecap').modal()
            },
            refreshRecap: function () {
                return this.loadRecap();
            },
            loadingComplete: function () {
                return this.recap_id == 0 ? true :
                    (this.getRecap != null && this.getStatusRecap != null)
            },
            loadStatutsRecaps: function () {
                this.$http.get(this.getRoute('getAllStatutsRecaps')).then((response) => {
                    this.setStatusRecap(response.body)
                }, (response) => {
                });
            },
            loadTextesEnvoi: function () {
                this.$http.get(this.getRoute('Secretariat.getTextesEnvoisRecapitulatif') + this.recap_id)
                    .then((response) => {
                        this.setTextesRecap(response.body)
                    }, (response) => {
                        this.setTextesRecap(null)
                    });
            },
            loadRecap: function () {
                this.loading = true
                if (this.recap_id == 0)
                    return;
                this.$http.get(this.getRoute('Secretariat.getInfosRecapitulatif') + this.recap_id)
                    .then((response) => {
                        this.setRecap(response.body)
                        this.loadTextesEnvoi();
                        this.loading = false
                    }, (response) => {
                        this.loading = false
                        this.setRecap(null)
                    });
            },
        },
        beforeRouteUpdate(to, from, next) {
            this.recap_id = to.params.recap_id;
            // console.log("Update to " + this.recap_id)
            this.setRecap(null)
            this.loadStatutsRecaps()
            this.loadRecap()
            next()

        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.recap_id = vm.$route.params.recap_id
                if (vm.$route.params.filterClub)
                    vm.clubSelectedForFilter = vm.$route.params.filterClub
                vm.setRecap(null)
                vm.loadStatutsRecaps()
                vm.loadRecap()
            })
        },
        watch: {},
        components: {
            MainFormRecap,
            ModalNewRecap,
            ListingRecap,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Recapitulatif/AppRecapitulatif.vue